module.exports = __webpack_public_path__ + "img/img_1@2x.ee32b847.png";